// eslint-disable-next-line @typescript-eslint/no-var-requires
export const DefaultImage = require('./loyalty-offer-card-default-img.jpg');
